import React, { useEffect, useState } from 'react';
import { getVisitCounts } from '../firebaseConfig';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import ProductAnalytics from './Analytics/ProductAnalytics';

const periods = ['day', 'week', 'month', 'year'];

const Dashboard = () => {
  const [period, setPeriod] = useState('day');
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const load = async () => {
      const { grouped, total } = await getVisitCounts(period);
      const formatted = Object.entries(grouped).map(([time, count]) => ({
        time,
        count,
      }));
      setData(formatted);
      setTotal(total);
    };
    load();
  }, [period]);

  return (
    <div className="bg-[#111111] p-2 rounded-2xl shadow-lg text-[#DBAE6E]">
      <h1 className="text-3xl font-bold mb-6">Site Visits</h1>
      <div className="flex flex-wrap gap-3 mb-6">
        {periods.map((p) => (
          <button
            key={p}
            onClick={() => setPeriod(p)}
            className={`rounded-full px-4 py-2 text-sm font-medium border transition-all ${
              p === period
                ? 'bg-[#DBAE6E] text-black border-[#DBAE6E]'
                : 'border-[#DBAE6E] text-[#DBAE6E] hover:bg-[#DBAE6E] hover:text-black'
            }`}
          >
            {p.charAt(0).toUpperCase() + p.slice(1)}: {period === p ? `(${total} Views)` : ''}
          </button>
        ))}
      </div>

      <div className="w-full h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <XAxis dataKey="time" stroke="#DBAE6E" />
            <YAxis stroke="#DBAE6E" allowDecimals={false} />
            <Tooltip
              contentStyle={{
                backgroundColor: '#000000',
                borderColor: '#DBAE6E',
                color: '#DBAE6E',
              }}
              labelStyle={{ color: '#DBAE6E' }}
              itemStyle={{ color: '#DBAE6E' }}
              wrapperStyle={{ outline: 'none' }}
            />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#DBAE6E"
              strokeWidth={2}
              dot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <ProductAnalytics />
    </div>
  );
};

export default Dashboard;
